import { FormikSelect } from '@/components/forms';
import { SelectGroup, SelectItem, SelectLabel } from '@/design-system/components/ui';

import { ContractFragment, EventType } from '../../../domain';
import { AbiFunctionDTO } from '../../../infra/dtos';

interface Props {
  selectedFunctionOrEvent: AbiFunctionDTO | ContractFragment;
  inputName:
    | 'volumeArgument'
    | 'revenueArgument'
    | 'currencyVolumeArgument'
    | 'currencyRevenueArgument'
    | 'endUserIdentifierExpression';
  type: EventType;
}

export default function SelectTriggerArgument({ selectedFunctionOrEvent, inputName, type }: Props) {
  const availableUintArguments = selectedFunctionOrEvent?.inputs.filter((input) => input.type.includes('int'));
  const availableAddressArguments = selectedFunctionOrEvent?.inputs.filter((input) =>
    ['address', 'bytes32'].includes(input.type),
  );

  const isAddressArgument = [
    'currencyVolumeArgument',
    'currencyRevenueArgument',
    'endUserIdentifierExpression',
  ].includes(inputName);

  const options = isAddressArgument ? availableAddressArguments : availableUintArguments;

  return (
    <FormikSelect name={`${inputName}.value`} label="Argument" className="tw:max-h-[55px] tw:max-w-[300px]">
      {options?.length ? (
        <SelectGroup>
          <SelectLabel>{type === EventType.OnChainFunction ? 'Function parameters' : 'Event parameters'}</SelectLabel>
          {options?.map((argument) => (
            <SelectItem key={argument.name} value={argument.name}>
              {argument.name} ({argument.type})
            </SelectItem>
          ))}
        </SelectGroup>
      ) : null}
      {!isAddressArgument ? (
        <SelectGroup>
          <SelectLabel>Transaction parameters</SelectLabel>
          <SelectItem value="msgValue">msgValue</SelectItem>
          <SelectItem value="transactionFee">Transaction fee</SelectItem>
        </SelectGroup>
      ) : null}
    </FormikSelect>
  );
}
